import React from 'react';
import { FooterContainer, FooterInner, FooterLogo, FooterLinks, FooterLink, FooterCopy } from './Footer.styles';

// Pie de las páginas públicas: bloque marino con logo blanco (BRAND.md).
const Footer = ({ attached = false }) => (
  <FooterContainer $attached={attached}>
    <FooterInner>
      <FooterLogo to="/">
        <img src="/assets/logos/logo-blanco-total.png" alt="BokerHub" />
      </FooterLogo>
      <FooterLinks>
        <FooterLink to="/search">Buscar actividades</FooterLink>
        <FooterLink to="/empresa">Para empresas</FooterLink>
        <FooterLink to="/promotor">Para promotores</FooterLink>
        <FooterLink to="/login">Iniciar sesión</FooterLink>
      </FooterLinks>
    </FooterInner>
    <FooterCopy>
      Reserva experiencias y crea recuerdos · © {new Date().getFullYear()} BokerHub
    </FooterCopy>
  </FooterContainer>
);

export default Footer;
